const ManagerSideMenu = [
  {
    title: 'Customer Information',
    is_heading: false,
    is_active: false,
    link: {
      name: 'manager.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'ri-home-4-line'
  }
]

export default ManagerSideMenu
